import {
    LegacyEpisodePlayerBaseInfoContent,
    MovieStreamFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getPreferredTracks } from '../../movie-player/utils/get-preferred-tracks';

import { getEpisodeOnlineStreams } from './get-episode-online-streams';
import { getTvSeriesWatchParams } from './get-tv-series-watch-params';

export function getEpisodePreferredTracks(
    episode: LegacyEpisodePlayerBaseInfoContent | undefined | null,
    getDefaultAudio?: (streams: MovieStreamFragment) => string | undefined
) {
    const watchParams = getTvSeriesWatchParams(episode);
    const onlineStreams = getEpisodeOnlineStreams(episode);

    return getPreferredTracks({
        watchParams,
        onlineStreams,
        getDefaultAudio,
    });
}
